import React, { useState } from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { crearEstrategia, cambiarEstadoEstrategia, eliminarEstrategia, armarPlanIA, crearRecordatorio } from '../services/metasService';
import { ideasDe, resumenParaIA } from '../utils/metasResumen';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';

const ACENTO = 'var(--color-primario,#DB2777)';
const tarjeta = { backgroundColor: 'white', borderRadius: '16px', padding: '16px', border: '1px solid #EEE9F8', marginBottom: '12px' };
const ESTADOS = [
  { k: 'pendiente', t: 'Por hacer', icono: '⚪', color: '#6B7280', fondo: '#F3F4F6' },
  { k: 'en_curso', t: 'En marcha', icono: '🟡', color: '#92400E', fondo: '#FEF3C7' },
  { k: 'hecha', t: 'Hecha', icono: '🟢', color: '#065F46', fondo: '#D1FAE5' },
];
const ORIGEN = { propia: '✍️ Mía', kontrol: '💡 Kontrol', ia: '✨ IA' };
// A dónde lleva cada idea de Kontrol (para hacerla en un toque).
const IR = { recompra: ['clientes', 'Abrir Clientes'], pedidos: ['pedidos', 'Abrir Pedidos'], reponer: ['stockbajo', 'Ver stock bajo'], productos: ['inventario', 'Ir a Inventario'] };

const manana9 = () => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); return d; };
const paraInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

// 🧭 Estrategias del mes: las propias, las ideas de Kontrol (según los números
// del negocio) y el plan con IA. Cada una se marca Por hacer / En marcha / Hecha.
export default function MetasEstrategias({ mes, meta, resumen, estrategias, setEstrategias, usoIA = 0, negocio, onIr, onRecordatorioCreado }) {
  const { mostrarToast } = useToast();
  const s = simboloMoneda();
  const [nueva, setNueva] = useState({ titulo: '', detalle: '' });
  const [plan, setPlan] = useState(null);
  const [pensando, setPensando] = useState(false);
  const [nota, setNota] = useState('');
  const [usados, setUsados] = useState(usoIA);
  const [agendar, setAgendar] = useState(null); // { id, cuando }

  const ya = new Set(estrategias.map((e) => e.titulo.trim().toLowerCase()));
  const ideas = ideasDe(resumen, s).filter((i) => !ya.has(i.titulo.trim().toLowerCase()));

  const agregar = async (titulo, detalle, origen) => {
    try {
      const e = await crearEstrategia(mes, { titulo, detalle, origen });
      setEstrategias((x) => [...x, e]);
      mostrarToast('🧭 Agregada a tu plan', 'exito');
      return e;
    } catch (err) { mostrarToast(mensajeAmigable(err), 'error'); return null; }
  };

  const cambiar = async (e, estado) => {
    try {
      await cambiarEstadoEstrategia(e.id, estado);
      setEstrategias((x) => x.map((y) => (y.id === e.id ? { ...y, estado } : y)));
      if (estado === 'hecha') mostrarToast('🎉 ¡Bien hecho! Una estrategia menos', 'exito');
    } catch (err) { mostrarToast(mensajeAmigable(err), 'error'); }
  };

  const borrar = async (e) => {
    if (!window.confirm(`¿Quitar "${e.titulo}" de tu plan?`)) return;
    try { await eliminarEstrategia(e.id); setEstrategias((x) => x.filter((y) => y.id !== e.id)); } catch (err) { mostrarToast(mensajeAmigable(err), 'error'); }
  };

  const pedirPlan = async () => {
    if (!meta) { mostrarToast('Primero guarda tu meta del mes', 'error'); return; }
    setPensando(true); setPlan(null);
    try {
      const r = await armarPlanIA(resumenParaIA(resumen, { negocio, meta, simbolo: s, estrategiasActuales: estrategias, nota }));
      setPlan(r);
      setUsados((u) => u + 1);
    } catch (err) { mostrarToast(err.message || 'No se pudo armar el plan', 'error', 6000); } finally { setPensando(false); }
  };

  const detalleIA = (e) => `${e.porque}\n${e.pasos.map((p, i) => `${i + 1}. ${p}`).join('\n')}`;

  const guardarAgenda = async (e) => {
    try {
      const r = await crearRecordatorio({ titulo: e.titulo, nota: 'Estrategia de tu plan del mes', cuando: agendar.cuando, estrategiaId: e.id });
      onRecordatorioCreado && onRecordatorioCreado(r);
      setAgendar(null);
      mostrarToast('⏰ Te lo recordamos a esa hora', 'exito');
    } catch (err) { mostrarToast(mensajeAmigable(err), 'error'); }
  };

  return (
    <div>
      {/* Mis estrategias */}
      <div style={tarjeta}>
        <p style={{ margin: '0 0 4px', fontWeight: 800, fontSize: '16px' }}>🧭 Mi plan para lograrlo</p>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#6B7280' }}>Lo que vas a hacer este mes. Muévelas a "En marcha" y "Hecha" conforme avances.</p>
        {estrategias.length === 0 && <p style={{ color: '#9CA3AF', fontSize: '14px' }}>Aún no tienes estrategias. Agrega una tuya, toma una idea de Kontrol o pídele un plan a la IA 👇</p>}
        {ESTADOS.map((st) => estrategias.filter((e) => e.estado === st.k).map((e) => (
          <div key={e.id} style={{ border: '1px solid #F1EEF8', borderRadius: '12px', padding: '10px 12px', marginBottom: '8px', background: e.estado === 'hecha' ? '#FAFFFB' : 'white' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
              <div style={{ minWidth: 0, flex: '1 1 260px' }}>
                <b style={{ fontSize: '14px', textDecoration: e.estado === 'hecha' ? 'line-through' : 'none', color: e.estado === 'hecha' ? '#6B7280' : '#1F1A2E' }}>{e.titulo}</b>
                <span style={{ fontSize: '11px', color: '#9CA3AF', marginLeft: '6px' }}>{ORIGEN[e.origen]}</span>
                {e.detalle && <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6B7280', whiteSpace: 'pre-wrap' }}>{e.detalle}</p>}
              </div>
              <div style={{ display: 'flex', gap: '4px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                {ESTADOS.map((x) => (
                  <button key={x.k} onClick={() => cambiar(e, x.k)} title={x.t}
                    style={{ padding: '5px 9px', borderRadius: '999px', fontSize: '12px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                      border: `1px solid ${e.estado === x.k ? x.color : '#E5E7EB'}`, background: e.estado === x.k ? x.fondo : 'white', color: e.estado === x.k ? x.color : '#9CA3AF' }}>
                    {x.icono} {x.t}
                  </button>
                ))}
                <button onClick={() => setAgendar({ id: e.id, cuando: paraInput(manana9()) })} title="Ponerle día y hora" className="k-btn-soft" style={{ fontSize: '12px', padding: '5px 9px' }}>⏰</button>
                <button onClick={() => borrar(e)} title="Quitar" className="k-btn-soft" style={{ fontSize: '12px', padding: '5px 9px' }}>🗑️</button>
              </div>
            </div>
            {agendar?.id === e.id && (
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '8px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '13px' }}>Recuérdamelo el</span>
                <input type="datetime-local" value={agendar.cuando} onChange={(ev) => setAgendar({ ...agendar, cuando: ev.target.value })}
                  style={{ padding: '7px', borderRadius: '8px', border: '1px solid #D1D5DB', fontSize: '13px' }} />
                <button onClick={() => guardarAgenda(e)} style={{ padding: '7px 12px', borderRadius: '8px', border: 'none', background: ACENTO, color: 'white', fontWeight: 700, cursor: 'pointer' }}>Guardar</button>
                <button onClick={() => setAgendar(null)} className="k-btn-soft" style={{ fontSize: '12px' }}>Cancelar</button>
              </div>
            )}
          </div>
        )))}
        <form onSubmit={(ev) => { ev.preventDefault(); if (!nueva.titulo.trim()) return; agregar(nueva.titulo, nueva.detalle, 'propia').then((e) => e && setNueva({ titulo: '', detalle: '' })); }}
          style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '10px' }}>
          <input className="k-input" value={nueva.titulo} maxLength={140} onChange={(ev) => setNueva({ ...nueva, titulo: ev.target.value })}
            placeholder="✍️ Escribe una estrategia tuya (ej: transmitir en vivo los jueves)" style={{ flex: '1 1 260px', marginBottom: 0 }} />
          <button type="submit" style={{ padding: '10px 16px', borderRadius: '10px', border: 'none', background: ACENTO, color: 'white', fontWeight: 700, cursor: 'pointer' }}>➕ Agregar</button>
        </form>
      </div>

      {/* Plan con IA */}
      <div style={{ ...tarjeta, background: 'linear-gradient(135deg,#F5F3FF 0%,#FDF2F8 100%)', borderColor: '#DDD6FE' }}>
        <p style={{ margin: '0 0 4px', fontWeight: 800, fontSize: '16px' }}>✨ Armar mi plan con IA</p>
        <p style={{ margin: '0 0 10px', fontSize: '13px', color: '#6B7280' }}>La IA revisa tus ventas, productos, gastos y clientas, y te propone estrategias a la medida para llegar a tu meta.</p>
        <textarea value={nota} onChange={(e) => setNota(e.target.value.slice(0, 400))} rows={2}
          placeholder="Opcional: ¿qué te gustaría lograr o qué te preocupa? (ej: vendo poco entre semana, quiero sacar la mercadería vieja…)"
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px', borderRadius: '10px', border: '1px solid #DDD6FE', fontSize: '13px', fontFamily: 'inherit', marginBottom: '8px' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <button onClick={pedirPlan} disabled={pensando || usados >= 10}
            style={{ padding: '11px 18px', borderRadius: '12px', border: 'none', background: 'linear-gradient(90deg,#6D28D9,#DB2777)', color: 'white', fontWeight: 800, cursor: pensando ? 'wait' : 'pointer', opacity: usados >= 10 ? 0.5 : 1, fontFamily: 'inherit' }}>
            {pensando ? '✨ Pensando tu plan… (unos 30 segundos)' : '✨ Armar mi plan'}
          </button>
          <small style={{ color: '#6B7280' }}>Te quedan {Math.max(0, 10 - usados)} de 10 este mes</small>
        </div>
        {plan && (
          <div style={{ marginTop: '14px' }}>
            <p style={{ margin: '0 0 10px', fontSize: '14px', background: 'white', borderRadius: '12px', padding: '10px 12px' }}>🧠 {plan.resumen}</p>
            {plan.estrategias.map((e, i) => {
              const agregada = ya.has(e.titulo.trim().toLowerCase());
              return (
                <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '12px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
                    <b style={{ fontSize: '14px' }}>{i + 1}. {e.titulo}</b>
                    <span style={{ fontSize: '11px', fontWeight: 700, color: e.impacto === 'alto' ? '#047857' : e.impacto === 'medio' ? '#B45309' : '#6B7280' }}>
                      Impacto {e.impacto} · semana {e.semana}
                    </span>
                  </div>
                  <p style={{ margin: '4px 0', fontSize: '13px', color: '#374151' }}>{e.porque}</p>
                  <ol style={{ margin: '4px 0 8px', paddingLeft: '20px', fontSize: '13px', color: '#4B5563' }}>{e.pasos.map((p, j) => <li key={j}>{p}</li>)}</ol>
                  <button onClick={() => agregar(e.titulo, detalleIA(e), 'ia')} disabled={agregada}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: 'none', background: agregada ? '#D1FAE5' : ACENTO, color: agregada ? '#065F46' : 'white', fontWeight: 700, cursor: agregada ? 'default' : 'pointer', fontSize: '12px' }}>
                    {agregada ? '✓ En tu plan' : '➕ Agregar a mi plan'}
                  </button>
                </div>
              );
            })}
            {plan.animo && <p style={{ margin: '6px 0 0', fontWeight: 700, color: '#5B21B6' }}>💜 {plan.animo}</p>}
          </div>
        )}
      </div>

      {/* Ideas de Kontrol */}
      <div style={tarjeta}>
        <p style={{ margin: '0 0 4px', fontWeight: 800, fontSize: '16px' }}>💡 Ideas de Kontrol para ti</p>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#6B7280' }}>Salen de tus números de hoy. Tómalas con un toque.</p>
        {ideas.length === 0 && <p style={{ color: '#9CA3AF', fontSize: '14px' }}>Ya agregaste todas las ideas. 🎉</p>}
        {ideas.map((i) => (
          <div key={i.clave} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #F3F4F6', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '22px' }}>{i.icono}</span>
            <div style={{ flex: '1 1 240px' }}>
              <b style={{ fontSize: '14px' }}>{i.titulo}</b>
              <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#6B7280' }}>{i.detalle}</p>
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {IR[i.clave] && onIr && <button onClick={() => onIr(IR[i.clave][0])} className="k-btn-soft" style={{ fontSize: '12px' }}>{IR[i.clave][1]}</button>}
              <button onClick={() => agregar(i.titulo, i.detalle, 'kontrol')} style={{ padding: '6px 12px', borderRadius: '8px', border: 'none', background: ACENTO, color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: '12px' }}>➕ A mi plan</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
